var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    { attrs: { dense: "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12", sm: "12", lg: "2" } },
        [
          _c(
            "v-layout",
            {
              staticClass: "pl-2",
              attrs: {
                "fill-height": "",
                "justify-center": "",
                "align-center": "",
              },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "unclickable-button",
                  attrs: {
                    color: _vm.status_color,
                    elevation: "2",
                    block: "",
                    depressed: "",
                  },
                },
                [_c("h3", [_vm._v(_vm._s(_vm.result.status.toUpperCase()))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "py-0",
          class: _vm.resultMessage ? "left" : "right",
          attrs: {
            cols: "12",
            sm: _vm.resultMessage ? 6 : 12,
            lg: _vm.resultMessage ? 5 : 10,
          },
        },
        [
          _c("h3", { staticClass: "pa-2" }, [_vm._v("Test")]),
          _c("v-divider"),
          _c("div", {
            staticClass: "pa-2 mono pre-formatted",
            domProps: {
              innerHTML: _vm._s(_vm.sanitize_html(_vm.result.code_desc.trim())),
            },
          }),
        ],
        1
      ),
      _vm.resultMessage
        ? _c(
            "v-col",
            { staticClass: "left", attrs: { cols: "12", sm: "6", lg: "5" } },
            [
              _c("h3", { staticClass: "pa-2" }, [_vm._v("Result")]),
              _c("v-divider"),
              _c("div", {
                staticClass: "pa-2 mono pre-formatted",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.sanitize_html(_vm.resultMessage.trim())
                  ),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.result["backtrace"] !== undefined
        ? _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12" } },
            [
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c("v-expansion-panel-header", [_vm._v("Backtrace")]),
                      _c(
                        "v-expansion-panel-content",
                        _vm._l(_vm.result.backtrace, function (trace, i) {
                          return _c(
                            "span",
                            { key: i, staticClass: "inline-text" },
                            [_vm._v(" " + _vm._s(trace) + " ")]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }